<form [formGroup]="realEstateEstimateForm" class="realEstateProjectForm">
  <div class="formDiv">
    <div formArrayName="estimates">
      <div class="tableHeader">
        <span class="workTask">Construction/Removal Work Task</span>
        <span class="expenditureType">Type of Expenditure</span>
        <span class="estimatedCost">Estimated Cost</span>
        <span class="detailProjectId">Detail Project ID</span>
        <span class="activityId">Activity ID</span>
        <span class="operatingUnitId">Operating Unit ID</span>
        <span class="processCode">Process Code</span>
        <span class="responsibilityCenter">Responsibility Center</span>
        <span class="accountNumber">Account Number</span>
        <span class="chargeType">Charge Type</span>
        <span class="projectChargeIndicator">Project Charge Indicator</span>
      </div>
      @for (estimate of estimatesArray.controls; track estimate; let i = $index) {
        <div [formGroupName]="i" class="tableBody">
          <!-- Work Task -->
          <mat-form-field class="workTask">
            <mat-select formControlName="workTask">
              @for (task of workTasks; track task) {
                <mat-option style="color: #696969" [value]="task.value">
                  <span>{{ task.value }}</span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!-- Type of Expenditure -->
          <mat-form-field class="expenditureType">
            <mat-select
              formControlName="expenditureType"
              (selectionChange)="onExpenditureTypeChange($event.value, i)"
            >
              @for (type of expenditureTypes; track type) {
                <mat-option style="color: #696969" [value]="type.value">
                  <span>{{ type.value }}</span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!-- Estimated Cost -->
          <mat-form-field class="estimatedCost">
            <input matInput formControlName="estimatedCost" appCurrencyMask appNumbersOnly />
            <span matPrefix>$</span>
          </mat-form-field>
          <!-- Detail Project ID -->
          <mat-form-field class="detailProjectId">
            <input matInput formControlName="detailProjectId" readonly class="disabledField" />
          </mat-form-field>
          <!-- Activity ID -->
          <mat-form-field class="activityId">
            <mat-select
              formControlName="activityId"
              (selectionChange)="onActivityIdChange($event.value, i)"
            >
              @for (
                activity of getFilteredActivityIds(
                  estimatesArray.at(i).get('expenditureType').value
                );
                track activity
              ) {
                <mat-option style="color: #696969" [value]="activity.valueId">
                  <span>{{ activity.valueId }}</span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!-- Operating Unit ID -->
          <mat-form-field class="operatingUnitId">
            <input matInput formControlName="operatingUnitId" readonly class="disabledField" />
          </mat-form-field>
          <!-- Process Code -->
          <mat-form-field class="processCode">
            <input
              matInput
              formControlName="processCode"
              [required]="estimate.get('activityId').value?.includes('Removal')"
            />
            @if (estimate.get('processCode').hasError('required')) {
              <mat-error> Process Code is required for Removal activities. </mat-error>
            }
          </mat-form-field>
          <!-- Responsibility Center -->
          <mat-form-field class="responsibilityCenter">
            <mat-select formControlName="responsibilityCenter">
              @for (center of respCenters; track center) {
                <mat-option style="color: #696969" [value]="center.value">
                  <span>{{ center.description }}</span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!-- Account Number -->
          <mat-form-field class="accountNumber">
            <input matInput formControlName="accountNumber" readonly class="disabledField" />
          </mat-form-field>
          <!-- Charge Type -->
          <mat-form-field class="chargeType">
            <mat-select formControlName="chargeType">
              @for (type of chargeTypes; track type) {
                <mat-option style="color: #696969" [value]="type.value">
                  <span>{{ type.value }}</span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!-- Project Charge Indicator -->
          <mat-form-field class="projectChargeIndicator">
            <input
              matInput
              formControlName="projectChargeIndicator"
              readonly
              class="disabledField"
            />
          </mat-form-field>
          <!-- Delete Button -->
          @if (!reviewMode) {
            <img
              style="cursor: pointer; width: 1rem; height: 1rem; margin-left: auto"
              src="assets/trash-bin-base.svg"
              (click)="deleteEstimate(i)"
            />
          }
        </div>
      }
      <div class="tableFooter pb-1 grey-border-bottom">
        @if (!reviewMode) {
          <span class="addButton" (click)="addEstimate()">
            <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
            <span class="addText"> Add New Material </span>
          </span>
        }
      </div>
    </div>
    <div formGroupName="chargeSummary">
      <div class="chargeContainer pb-1 grey-border-bottom pt-1">
        <div class="chargeColumn chargeHeader">Charge Type Summary</div>
        <div class="chargeColumn chargeHeader">Capital Additions</div>
        <div class="chargeColumn chargeHeader">Capital - Cost of Removal</div>
        <div class="chargeColumn chargeHeader">O&M</div>
        <div class="chargeColumn chargeHeader">Total</div>
      </div>

      <div class="chargeContainer">
        <div class="chargeColumn">Labor (Duke Energy Labor)</div>
        <!-- Capital Additions -->
        <div class="chargeColumn">
          {{
            chargeSummaryGroup.get('laborCapitalAdditions').value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Capital Cost of Removal -->
        <div class="chargeColumn">
          {{
            chargeSummaryGroup.get('laborCostOfRemoval').value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- O&M -->
        <div class="chargeColumn">
          {{ chargeSummaryGroup.get('laborOM').value | currency: 'USD' : 'symbol' : '1.0-0' }}
        </div>
        <!-- Total -->
        <div class="chargeColumn">
          {{ chargeSummaryGroup.get('laborTotal').value | currency: 'USD' : 'symbol' : '1.0-0' }}
        </div>
      </div>

      <div class="chargeContainer">
        <div class="chargeColumn">Contractor</div>
        <!-- Capital Additions -->
        <div class="chargeColumn">
          {{
            chargeSummaryGroup.get('contractorCapitalAdditions').value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Capital Cost of Removal -->
        <div class="chargeColumn">
          {{
            chargeSummaryGroup.get('contractorCostOfRemoval').value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- O&M -->
        <div class="chargeColumn">
          {{ chargeSummaryGroup.get('contractorOM').value | currency: 'USD' : 'symbol' : '1.0-0' }}
        </div>
        <!-- Total -->
        <div class="chargeColumn">
          {{
            chargeSummaryGroup.get('contractorTotal').value | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
      </div>

      <div class="chargeContainer">
        <div class="chargeColumn">Materials</div>
        <!-- Capital Additions -->
        <div class="chargeColumn">
          {{
            chargeSummaryGroup.get('materialCapitalAdditions').value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Capital Cost of Removal -->
        <div class="chargeColumn">
          {{
            chargeSummaryGroup.get('materialCostOfRemoval').value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- O&M -->
        <div class="chargeColumn">
          {{ chargeSummaryGroup.get('materialOM').value | currency: 'USD' : 'symbol' : '1.0-0' }}
        </div>
        <!-- Total -->
        <div class="chargeColumn">
          {{ chargeSummaryGroup.get('materialTotal').value | currency: 'USD' : 'symbol' : '1.0-0' }}
        </div>
      </div>

      <div class="chargeContainer">
        <div class="chargeColumn">Other</div>
        <!-- Capital Additions -->
        <div class="chargeColumn">
          {{
            chargeSummaryGroup.get('otherCapitalAdditions').value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Capital Cost of Removal -->
        <div class="chargeColumn">
          {{
            chargeSummaryGroup.get('otherCostOfRemoval').value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- O&M -->
        <div class="chargeColumn">
          {{ chargeSummaryGroup.get('otherOM').value | currency: 'USD' : 'symbol' : '1.0-0' }}
        </div>
        <!-- Total -->
        <div class="chargeColumn">
          {{ chargeSummaryGroup.get('otherTotal').value | currency: 'USD' : 'symbol' : '1.0-0' }}
        </div>
      </div>

      <div class="chargeContainer grey-border-bottom pb-1">
        <div class="chargeColumn">Total Project Approved Funding</div>
        <!-- Capital Additions -->
        <div class="chargeColumn">
          {{
            chargeSummaryGroup.get('approvedCapitalAdditions').value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Capital Cost of Removal -->
        <div class="chargeColumn">
          {{
            chargeSummaryGroup.get('approvedCostOfRemoval').value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- O&M -->
        <div class="chargeColumn">
          {{ chargeSummaryGroup.get('approvedOM').value | currency: 'USD' : 'symbol' : '1.0-0' }}
        </div>
        <!-- Total -->
        <div class="chargeColumn">
          {{ chargeSummaryGroup.get('approvedTotal').value | currency: 'USD' : 'symbol' : '1.0-0' }}
        </div>
      </div>
    </div>

    <div formGroupName="expenditureSummary">
      <div class="projectScopeHeader pt-1">Summary of Expenditures</div>
      <div class="chargeContainer pb-1 grey-border-bottom">
        <div class="chargeColumn chargeHeader">Summary</div>
        <div class="chargeColumn chargeHeader">Previous Funding</div>
        <div class="chargeColumn chargeHeader">Current Funding Request</div>
        <div class="chargeColumn chargeHeader">Total Project Funding</div>
      </div>

      <div class="chargeContainer">
        <div class="chargeColumn">Estimated Capital Cost</div>
        <!-- Previous Funding -->
        <!-- previous funding should be pulled from previous form when making a revision -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('previousEstCapCost')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Current Funding Request -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('currentEstCapCost')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Total -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('totalEstCapCost')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
      </div>

      <div class="chargeContainer">
        <div class="chargeColumn">Estimated AFUDC</div>
        <!-- Previous Funding -->
        <!-- previous funding should be pulled from previous form when making a revision -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('previousEstAFUDC')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Current Funding Request -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('currentEstAFUDC')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Total -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('totalEstAFUDC')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
      </div>

      <div class="chargeContainer">
        <div class="chargeColumn">Total Capital</div>
        <!-- Previous Funding -->
        <!-- previous funding should be pulled from previous form when making a revision -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('previousTotalCapital')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Current Funding Request -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('currentTotalCapital')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Total -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('totalTotalCapital')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
      </div>

      <div class="chargeContainer">
        <div class="chargeColumn">Estimated O&M Costs</div>
        <!-- Previous Funding -->
        <!-- previous funding should be pulled from previous form when making a revision -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('previousEstOM')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Current Funding Request -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('currentEstOM')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Total -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('totalEstOM')?.value | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
      </div>

      <div class="chargeContainer">
        <div class="chargeColumn">Total Project Funding without AFUDC</div>
        <!-- Previous Funding -->
        <!-- previous funding should be pulled from previous form when making a revision -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('previousTotalNoAFUDC')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Current Funding Request -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('currentTotalNoAFUDC')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Total -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('totalTotalNoAFUDC')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
      </div>

      <div class="chargeContainer grey-border-bottom pb-1">
        <div class="chargeColumn">Total Project Funding including AFUDC</div>
        <!-- Previous Funding -->
        <!-- previous funding should be pulled from previous form when making a revision -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('previousTotalWithAFUDC')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Current Funding Request -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('currentTotalWithAFUDC')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
        <!-- Total -->
        <div class="chargeColumn">
          {{
            expenditureSummaryGroup.get('totalTotalWithAFUDC')?.value
              | currency: 'USD' : 'symbol' : '1.0-0'
          }}
        </div>
      </div>
    </div>
  </div>
</form>
